export const extractUrn = (urn?: string) => {
  if (!urn) {
    return {
      category: "",
      source: "",
      scope: "",
      method: "",
      type: "",
    };
  }
  const items = urn.split(":");
  return {
    category: items[0],
    source: items[1],
    scope: items[2],
    method: items[3],
    type: items[4],
  };
};

function rstrip(str: string, char: string) {
  const regex = new RegExp(char + "+$");
  return str.replace(regex, "");
}

export const constructUrn = ({
  category,
  source,
  scope,
  method,
  type,
}: {
  category: string;
  source: string;
  scope: string;
  method: string;
  type: string;
}) => {
  let urn = `${category}:${source ?? ""}:${scope ?? ""}:${method ?? ""}:${type ?? ""}`;
  return rstrip(urn, ":");
};
